import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAutocompleteDataLoader } from 'src/app/components/autocomplete/abstract-autocomplete-data-loader';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { RecommendationService } from '../recommendation/recommendation.service';

@Injectable({
  providedIn: 'root'
})
export class UserDefinedStatusesAutocompleteDataLoaderService extends AbstractAutocompleteDataLoader {

  constructor(private recommendationService: RecommendationService) {super();}

  load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ search: searchTerm };
    return this.recommendationService.autocompleteUserDefinedStatuses(postFilterFields)
      .pipe(
          map(response => {
            if (response.success) {
              response.payload = this.fromDictionary(response.payload);
            }
            return response;
          })
      );
  }

  loadAll(): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ searchAll: true };
    return this.recommendationService.autocompleteUserDefinedStatuses(postFilterFields)
      .pipe(
          map(response => {
            if (response.success) {
              response.payload = this.fromDictionary(response.payload);
            }
            return response;
          })
      );
  }
}
